import { render, staticRenderFns } from "./salepoints.vue?vue&type=template&id=14fc9e9d&scoped=true&"
import script from "./salepoints.vue?vue&type=script&lang=js&"
export * from "./salepoints.vue?vue&type=script&lang=js&"
import style0 from "./salepoints.vue?vue&type=style&index=0&id=14fc9e9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc9e9d",
  null
  
)

export default component.exports